/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./resources/js/global-listeners.js ***!
  \******************************************/
// Global Listeners -- START
document.addEventListener("DOMContentLoaded", function () {
  console.log("Initialising global QF listeners");

  // Product Forms -- START
  var productForms = document.querySelectorAll('[action="/cart/add"]');
  var _loop = function _loop() {
    var productForm = productForms[i];
    //let data = productForm.dataset;

    productForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var quantity = productForm.querySelector('[name="quantity"]');
      var id = productForm.querySelector('[name="id"]').value;
      var sellingplan = productForm.querySelector('[name="selling_plan"]');

      //const gift_checkbox = document.querySelector('#gift-wrapping');
      //const gift_id = gift_checkbox.getAttribute('data-id');

      // function addGiftWrapping() {
      //   window.qf_cart.addToCart(gift_id, 1);
      // }

      // if (gift_checkbox.checked) {
      //   if (quantity && id) {

      //     window.qf_cart.addToCart(id, quantity, {"gift-wrapping": "Yes"}, null, null, addGiftWrapping);

      //   }
      // }

      if (sellingplan && quantity && id) {
        if (sellingplan.value) {
          var quantity_value = productForm.querySelector('[name="quantity"]').value;
          window.qf_cart.addToCart(id, quantity_value, sellingplan.value);
        } else {
          var _quantity_value = productForm.querySelector('[name="quantity"]').value;
          window.qf_cart.addToCart(id, _quantity_value);
        }
      } else if (sellingplan && id) {
        if (sellingplan.value) {
          window.qf_cart.addToCart(id, 1, sellingplan.value);
        } else {
          window.qf_cart.addToCart(id, 1);
        }
      } else if (quantity && id) {
        var _quantity_value2 = productForm.querySelector('[name="quantity"]').value;
        window.qf_cart.addToCart(id, _quantity_value2);
      } else if (id) {
        window.qf_cart.addToCart(id, 1);
      }
    });
  };
  for (var i = 0; i < productForms.length; i++) {
    _loop();
  }

  // PRODUCT QUICK ADD
  var quickAdds = document.querySelectorAll('[quick-add-qf]');
  if (quickAdds) {
    quickAdds.forEach(function (quickAdd) {
      quickAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (quickAdd.dataset.id && quickAdd.dataset.quantity && quickAdd.dataset.quantity > 0) {
          window.qf_cart.addToCart(quickAdd.dataset.id, quickAdd.dataset.quantity);

          // Update cart count on add
          var renderCartCount = function renderCartCount() {
            var cartCount = document.querySelectorAll(".cart-count");
            cartCount.forEach(function (count) {
              count.innerHTML = window.cart.cart.items.length;
            });
          };
          window.addEventListener("cart_changed", renderCartCount);
        }
      });
    });
  }

  // Side Cart - START
  // Open side cart
  var sideCartOpen = document.querySelectorAll(".openSideCart");
  if (sideCartOpen) {
    sideCartOpen.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        window.qf_side_cart.openSideCart();
      });
    });
  }

  // Close side cart
  var sideCartClose = document.querySelectorAll(".closeSideCart");
  if (sideCartClose) {
    sideCartClose.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        window.qf_side_cart.closeSideCart();
      });
    });
  }
  // Side Cart - END

  function addCartItemListeners() {
    console.log("adding listeners");
    var remove_btns = document.querySelectorAll(".cart .items-wrapper .item .remove-item");
    var quantitySelectors = document.querySelectorAll(".cart .items-wrapper .item .quantity-wrapper");
    quantitySelectors.forEach(function (el, i) {
      var plus = el.querySelector(".plus");
      var minus = el.querySelector(".minus");
      plus.addEventListener("click", function () {
        var pending = plus.getAttribute("data-pending") == "true";
        if (pending) {
          return false;
        }
        plus.setAttribute("data-pending", true);
        var quantity = plus.parentNode.querySelector(".quantity span");
        var current = parseInt(quantity.innerHTML);
        var stock = quantity.getAttribute("data-stock");
        var variant_id = quantity.getAttribute("data-variant-id");
        var inv_policy = quantity.getAttribute("data-inventory-policy");
        if (inv_policy == "continue" || stock > 0) {
          var updated = current + 1;
          window.qf_cart.updateCart(variant_id, updated);
        }
      });
      minus.addEventListener("click", function () {
        var pending = minus.getAttribute("data-pending") == "true";
        if (pending) {
          return false;
        }
        minus.setAttribute("data-pending", true);
        var quantity = minus.parentNode.querySelector(".quantity span");
        var current = parseInt(quantity.innerHTML);
        var variant_id = quantity.getAttribute("data-variant-id");
        if (current > 0) {
          var updated = current - 1;
          window.qf_cart.updateCart(variant_id, updated);
        }
      });
    });
    remove_btns.forEach(function (el) {
      el.addEventListener("click", function () {
        var variant_id = el.getAttribute("data-variant-id");
        //let item_properties = el.parentElement.parentElement.parentElement.parentElement.getAttribute('data-line-item');

        // function removeGiftwrapping() {
        //   window.qf_cart.removeFromCart(43557724193017);
        // }

        // if (item_properties) {
        //   if (item_properties == 'gift-wrappingYes') {
        //     window.qf_cart.removeFromCart(variant_id, removeGiftwrapping);
        //   } else {
        //     window.qf_cart.removeFromCart(variant_id);
        //   }
        // } else {
        //   window.qf_cart.removeFromCart(variant_id);
        // }

        window.qf_cart.removeFromCart(variant_id);
      });
    });
  }

  // attached side cart event listeners after side cart update
  window.addEventListener("cart_rendered", function (e) {
    addCartItemListeners();
  });

  // update side cart/cart after change
  var renderCarts = function renderCarts() {
    if (window.template == "cart") {
      window.qf_cart.reRenderCart();
    } else {
      window.qf_side_cart.openSideCart();
    }
  };
  window.addEventListener("cart_changed", renderCarts);
  window.addEventListener("item_removed", renderCarts);

  // Updated cart count on cart changed
  var cartCount = document.querySelectorAll(".cart-count");
  if (cartCount) {
    cartCount.forEach(function (count) {
      window.addEventListener("cart_changed", function (e) {
        window.qf_cart.getCart(function (response) {
          count.innerHTML = response.data.item_count;
        });
      });
      window.addEventListener("item_removed", function (e) {
        window.qf_cart.getCart(function (response) {
          count.innerHTML = response.data.item_count;
        });
      });
    });
  }
});

// Global Listeners -- END
/******/ })()
;